/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useEffect } from 'react'

import styled from 'styled-components'

import { Breakpoints } from 'src/utilities/Breakpoints'
import { ThemeProvider } from 'src/utilities/ThemeContext'
import { storeUtmParams } from 'src/utilities/utmUtils'

// ignore sort order for these imports
// prettier-ignore
// import '../../styles/Fonts.css'
// import '../../styles/Layout.css'
import '../../styles/hljs.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const theme = {
  breakpoints: {
    values: { ...Breakpoints },
    up: key => `(min-width:${Breakpoints[key]}px)`,
    down: key => `(max-width:${Breakpoints[key] - 1}px)`
  }
}

const OverflowWrapper = styled.div`
  /* overflow: hidden; */
  position: relative;
`
const loadCustomUtils = () => {
  useEffect(() => {
    storeUtmParams()
  }, [])
}

export default ({ children }) => {
  loadCustomUtils()
  return (
    <ThemeProvider theme={theme}>
      <OverflowWrapper className='layoutWrapper'>{children}</OverflowWrapper>
    </ThemeProvider>
  )
}
